import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  CardHeader,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import DateTime from 'react-datetime'
import ReactSelect from 'components/Form/Select/Select'
// import AsyncSelect from 'components/Form/Select/AsyncSelect'
import AsyncSelect from 'react-select/async'
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import useToggle from "../../lib/useToggle"
import Loading from 'lib/loading'
import useForm from "../../lib/useForm"
import FromVenda from "./form"
import './style.css'

const colunas = [
  {
    dataField: 'venda_nota_id',
    text: 'Venda',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'nf_id',
    text: 'NFC-e',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'vendedor',
    text: 'Vendedor',
    align: 'left',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'venda_data_hora',
    text: 'Data',
    align: 'center',
    headerStyle: { cursor: 'default' },
    sort:true
  },
  {
    dataField: 'venda_total',
    text: 'Total',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'venda_recebido',
    text: 'Recebido',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'fantasia',
    text: 'Loja',
    align: 'center',
    headerStyle: { cursor: 'default' },
    sort:true
  },
  {
    dataField: 'filial_id',
    text: 'filial_id',
    align: 'center',
    hidden: true,
    headerStyle: { cursor: 'default' },    
  },
  {
    dataField: 'cancelado',
    text: 'Cancelado',
    align: 'center',
    headerStyle: { cursor: 'default' },
    formatter: (cellContent, row) => {
      if (row.cancelado === 'Sim') {
        return (<div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">{row.cancelado}</span></div>)
      }else{
        return (<div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">{row.cancelado}</span></div>)
      }
    }
  }
]

const inicialForm = {
  venda_nota_id   : '',
  nf_id           : '',
  produto_id      : '',
  produtoSelect   : [],
  vendedor_id     : [],
  vendedorSelect  : [],
  filial_id       : [],
  filialSelect    : [],
  data_inicio     : '',
  data_final      : '',
  order_field     : '',
  order_sort      : ''
}

const Vendas = () => {
  
  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [loading, setLoading]                                   = useState(true)
  const [modal, setModal]                                       = useToggle(false)
  const [listaVendedores, setListaVendedores]                   = useState([])
  const [listaLojas, setListaLojas]                             = useState([])
  const [listaVendas, setListaVendas]                           = useState([])
  const [listaProdutos, setListaProdutos]                       = useState([])
  const [countLista, setCountLista]                             = useState(0)
  const [venda_nota_id, setVenda_nota_id]                       = useState(null)
  const [filial_id, setFilial_id]                               = useState(null)
  const [tablePage, setTablePage]                               = useState([])

  
  const paginationOption = {
    sizePerPage: 10,
    totalSize: countLista,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: false,
  }

  const loadsProdutos = (inputValue) => {
    
    if (inputValue.length > 3) {
      
      return produtos(inputValue)
    }
  }

  const  produtos = async (filtro) => {
    let lista = []
    const url = rotas.produto
    try{
      const retorno = rest.post(url, {'filtro':filtro})
      return retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"value":ret.lista[i].produto_id, "label":ret.lista[i].produto}
          }
          return(lista)
        }
      })

    }catch(err){
      console.log(err)
      return ('Nenhum')
    }
  }

  const vendedores = () => {
    let lista = [{id: 0, title: 'TODOS'}]
    const url = rotas.vendedor
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].vendedor_id, "title":ret.lista[i].vendedor}
          }
          setListaVendedores(lista)
        }
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const lojas = () => {
    let lista = [{id: 0, title: 'TODAS'}]
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
        setListaLojas(lista)
        }
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const vendas = (type=null, filtros=null) => {
    setListaVendas([]);

    if(type === 'sort'){
      form.order_field = filtros.sortField;
      form.order_sort = filtros.sortOrder;
    }else{
      form.order = '';
    }

    let pagina = 1
    if (filtros) {
      pagina = filtros.page
    }
    
    const url = rotas.vendas+pagina
    try{
      let retorno = ''
      retorno = rest.post(url, form)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S') {
          if (ret.lista != '') {
            setListaVendas(ret.lista)
            if (pagina === 1) {
              setCountLista(ret.total)
            }
          }else{
            setListaVendas([])
            setCountLista(0)
          }
        }else{
          setListaVendas([])
          setCountLista(0)
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()
    if (tablePage) {
      tablePage.paginationContext.currPage = 1
    }
    vendas(null, null)
  }

  useEffect(() => {
    vendedores()
    lojas()
    // vendas()
    if (loading === true) {
      setLoading(false);
    }
  }, [])

  const abreModal = (venda_nota_id, filial_id) => {
    setVenda_nota_id(venda_nota_id)
    setFilial_id(filial_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>VENDAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {/* painel do filtro */}
                  <div className="border p-3">
                    <Form onSubmit={handleSubmit}>
                      <Container>
                        <Row>
                          <Col md='3'>
                            <FormGroup className="mb-0">
                              <Input
                                name        = "venda"
                                placeholder = "Pré-Venda"
                                value       = {form.venda_nota_id}
                                onChange    = {onChange('venda_nota_id')}
                              ></Input>
                            </FormGroup>
                          </Col>

                          <Col md='3'>
                            <FormGroup className="mb-0">
                              <Input
                                name        = "nf_id"
                                placeholder = "NFC-e"
                                value       = {form.nf_id}
                                onChange    = {onChange('nf_id')}
                              ></Input>
                            </FormGroup>
                          </Col>

                          {/* <Col md='3'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name        = "lojas"
                                placeholder = "Produto"
                                // options       = {listaLoja}
                                // defaultValue  = {form.filialSelect}
                                // onChange      = {onChangeSelect('filialSelect')}
                                // onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col> */}
                          
                          <Col md='6'>
                            <FormGroup className="mb-0">
                              <AsyncSelect
                                // cacheOptions 
                                name        = "produtos"
                                placeholder = "Produto"
                                value       = {form.produtoSelect}
                                loadOptions = {loadsProdutos}
                                onChange    = {onChangeSelect('produtoSelect')}
                                onClick     = {form.produtoSelect.value ? form.produto_id = form.produtoSelect.value : ''}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col md='4'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name        = "vendedor"
                                placeholder = "Vendedor"
                                options       = {listaVendedores}
                                defaultValue  = {form.vendedorSelect}
                                onChange      = {onChangeSelect('vendedorSelect')}
                                onClick       = {form.vendedorSelect ? form.vendedor_id = form.vendedorSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          <Col md='3'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name="loja"
                                placeholder="Loja"
                                options       = {listaLojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial_id = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.data_inicio}
                                onChange      = {onChangeDate('data_inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.data_final}
                                onChange      = {onChangeDate('data_final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md="1" className="">
                            <Button
                              className = "w-100 m-0"
                              type      = "submit"
                              color     = "success"
                              style     = {{ padding: '6px' }}
                            >
                              <i className="nc-icon nc-zoom-split"
                                style = {{ fontSize: '25px' }}
                              >
                              </i>
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                    </Form>
                  </div>

                  
                  <ToolkitProvider
                    keyField="venda_nota_id"
                    data={listaVendas}
                    columns={colunas}
                    search
                    // hiddenRows={ [5,6] }
                  >
                    {
                      props => (
                        <BootstrapTable
                          striped
                          hiddenRows={ [1, 5, 6] }
                          remote={{ search: true, pagination: true }}
                          ref={(n) => (setTablePage(n))}
                          pagination={paginationFactory(paginationOption)}
                          onTableChange={vendas}
                          {...props.baseProps}
                          id='idtrapTbleVendas'
                          keyField='venda_nota_id'
                          data={listaVendas}
                          columns={colunas}
                          noDataIndication="Nenhum registro encontrado"
                          rowEvents={
                            {
                              onDoubleClick: (e, row, rowIndex) => {
                                abreModal(row.venda_nota_id, row.filial_id)
                              }
                            }
                          }
                          rowStyle={{ cursor: "pointer" }}
                        />
                      )
                    }
                  </ToolkitProvider>

                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Venda</ModalHeader>
                    <ModalBody>
                      <FromVenda
                        fechaModal    = {setModal}
                        venda_nota_id = {venda_nota_id}
                        filial_id     = {filial_id}
                      ></FromVenda>
                    </ModalBody>
                  </Modal>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Vendas;